module.exports = __webpack_public_path__ + "img/b079a1a.png";